export const GET_USERS_REQUEST = 'GET_USERS_REQUEST';
export const SET_USERS = 'SET_USERS';
export const SET_LOADING = 'SET_LOADING';
export const ADD_USER = 'ADD_USER';
export const ADD_USER_REQUEST = 'ADD_USER_REQUEST';
export const DELETE_USER_REQUEST = 'DELETE_USER_REQUEST';
export const DELETE_USER = 'DELETE_USER';
export const EDIT_USER = 'EDIT_USER';
export const EDIT_USER_REQUEST = 'EDIT_USER_REQUEST';

export const getUsers = () => ({
  type: GET_USERS_REQUEST,
});

export const setUsers = (data) => ({
  type: SET_USERS,
  data,
});

export const setLoading = (data) => ({
  type: SET_LOADING,
  data,
});

export const addUser = (data) => ({
  type: ADD_USER,
  data,
});

export const addUserRequest = (data) => ({
  type: ADD_USER_REQUEST,
  data,
});

export const deleteUserRequest = (data) => ({
  type: DELETE_USER_REQUEST,
  data,
});

export const deleteUser = (data) => ({
  type: DELETE_USER,
  data,
});

export const editUser = (data) => ({
  type: EDIT_USER,
  data,
});

export const editUserRequest = (data) => ({
  type: EDIT_USER_REQUEST,
  data,
});
